import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
// import { useDispatch } from "react-redux";
// import { AppDispatch } from "../../reduxStore/store";
//import { ForgotPasswordBody } from "../../reduxStore/forgotPassword/Model";
// import { useAppSelector } from "../../reduxStore/hooks";
import {
  AlertColor,
  InputAdornment,
} from "@mui/material";
import MedicalWisdomSnackbar from "../../components/MedicalWisdomSnackbar";
import { useForm } from "react-hook-form";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import mw from "../../assets/images/logo/mw.png";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FORGOT_PASSWORD_SUB_TITLE } from "../../constants/staticText";
// import {
//   forgotPassword,
//   updateForgotPasswordClearRes,
// } from "../../reduxStore/forgotPassword/forgotPasswordSlice";
// import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";

interface IFormInput {
  username: string;
}

// yup schema
const schema = yup.object().shape({
  username: yup.string().required("Username is a required field"),
});

export default function ForgotPassword() {
  // const dispatch = useDispatch<AppDispatch>();
  let navigate = useNavigate();
  const [forgotPasswordMsgType] =
    React.useState<AlertColor>("success");
  const closeForgotPasswordSnackbar = () => {
    // dispatch(updateForgotPasswordClearRes());
    setForgotPasswordMsg("");
  };

  const handleClickBackToLogin = () => {
    console.log("handleClickBackToLogin");
    navigate("/login");
  };

  const [forgotPasswordMsg, setForgotPasswordMsg] = React.useState("");
  // const forgotPasswordDetails = useAppSelector((state) => state.forgotPassword);

  // React.useEffect(() => {
  //   if (forgotPasswordDetails?.successMsg !== "") {
  //     setForgotPasswordMsgType("success");
  //     setForgotPasswordMsg(forgotPasswordDetails?.successMsg);
  //     setTimeout(() => {
  //       dispatch(updateForgotPasswordClearRes());
  //     }, 100);
  //   }
  //   if (forgotPasswordDetails?.error !== "") {
  //     setForgotPasswordMsg(forgotPasswordDetails?.error);
  //     setForgotPasswordMsgType("error");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [forgotPasswordDetails]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormInput>({ resolver: yupResolver(schema) });

  // forgot password form submit
  const onSubmit = (data: IFormInput) => {
    // const ForgotPasswordBody = {
    //   username: data.username,
    // } as ForgotPasswordBody;
    // dispatch(forgotPassword(ForgotPasswordBody));
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignSelf: "center",
        gap: 1,
      }}
    >
      <Box>
        <img
          src={mw}
          width="250"
          height="42"
          style={{
            objectFit: "cover",
            objectPosition: "left",
          }}
          alt="Medical Wisdom logo"
        />
      </Box>
      <Box sx={{ py: 2 }}>
        <Typography variant="h4" className="heading" sx={{ padding: 0, mb: 0 }}>
          Forgot Password
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ padding: 0, mb: 0, lineHeight: 1 }}
        >
          {FORGOT_PASSWORD_SUB_TITLE}
        </Typography>
      </Box>

      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <TextField
          placeholder="Username"
          autoFocus
          required
          fullWidth
          variant="outlined"
          size="small"
          autoComplete="new-password"
          {...register("username")}
          error={Boolean(errors.username)}
          helperText={errors!.username?.message!}
          sx={{ pb: 3 }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <PermIdentityIcon />
                </InputAdornment>
              ),
            },
          }}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="medium"
          sx={{ my: 1 }}
          style={{ textTransform: "none" }}
          // disabled={forgotPasswordDetails?.loading}
        >
          {/* {forgotPasswordDetails.loading === true ? (
            <Stack direction="row" spacing={1}>
              <Typography> Send password reset email</Typography>
              <Box pl={1}>
                <CircularProgress color="inherit" size={18} />
              </Box>
            </Stack>
          ) : (
            "Send password reset email"
          )} */}
          Send password reset email
        </Button>
      </form>
      {/* {forgotPasswordDetails?.successMsg !== "" ? (
        <Alert severity="success">
          A password reset link has been sent to your email.
        </Alert>
      ) : null} */}

      <Grid
        container
        direction="row"
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Link
          component="button"
          onClick={handleClickBackToLogin}
          variant="body2"
          underline="hover"
          sx={{
            alignSelf: "baseline",
            fontWeight: "bold",
          }}
        >
          Back to Sign in
        </Link>
      </Grid>

      <MedicalWisdomSnackbar
        msg={forgotPasswordMsg}
        type={forgotPasswordMsgType}
        alertClose={closeForgotPasswordSnackbar}
      />
    </Box>
  );
}
